import React, { useState } from "react";
import { getEditUrl, getProductName, unableToEditProduct } from "../utils";

import { AdviceDialog } from "Components/AdviceDialog/AdviceDialog";
import { useTexts } from "Components/TextContext";
import { Variants } from "Components/TextContext/textConstants";
import { MainPath } from "Constants/constants";
import { useIsAdviceProduct } from "Store/advice/hooks";
import { useCurrentCart } from "Store/cart/cartHooks";
import { InsuranceProduct } from "Store/interfaces/products/checkout";
import { useEditProductURLTexts } from "Store/texts/hooks";
import { buttonTrackId } from "Utils/analytics";
import { getCartPartner } from "Utils/cartUtils";
import { useHistory } from "react-router";
import { ResponsiveButton } from "../editableCardFooterStyled";
import { usePartnerToggle } from "./usePartnerToggle";

interface Props {
  readonly product: InsuranceProduct;
}

export const EditButton = ({ product }: Props): React.ReactElement | null => {
  const { getText } = useTexts();
  const [editProductURLs] = useEditProductURLTexts();
  const cart = useCurrentCart();
  const history = useHistory();

  const isAdviceProduct = useIsAdviceProduct(product);
  const cartPartner = cart !== null ? getCartPartner(cart) : undefined;

  const [open, setOpen] = useState(false);
  const openDrawer = (): void => {
    setOpen(true);
  };
  const closeDrawer = (): void => {
    setOpen(false);
  };

  const editButtonTrackId = getText("insurancecard.button.edit", {
    variant: Variants.ENGLISH,
  });

  const isPartnerToggled = usePartnerToggle(cart);
  const productName = getProductName(product, isAdviceProduct);

  const hideEditButton = unableToEditProduct(product);
  if (hideEditButton) {
    return null;
  }

  const editUrl = getEditUrl(
    {
      productName,
      cartPartner,
      isPartnerToggled,
    },
    {
      productURL: editProductURLs[productName],
      cartId: cart?.cartId ?? "",
      productId: product.productId,
    },
  );

  const editButtonClick = (): void => {
    if (isAdviceProduct && cart?.cartOwnedByAdvisor) {
      openDrawer();
    } else {
      if (editUrl.startsWith(`/${MainPath.CHECK_PRICE}`)) {
        history.push(editUrl);
      } else {
        window.open(editUrl, "_self", "noopener,noreferrer");
      }
    }
  };

  return (
    <>
      <ResponsiveButton
        variant="text"
        data-link={editUrl}
        onClick={editButtonClick}
        trackId={buttonTrackId(editButtonTrackId)}
        iconLeft="edit"
        paddingLeft={0}
      >
        {!isAdviceProduct
          ? getText("insurancecard.button.edit")
          : getText("insurancecard.button.editorremove")}
      </ResponsiveButton>
      <AdviceDialog open={open} closeDrawer={closeDrawer} forEditButton />
    </>
  );
};
